<template>
    <div class="wrapper">
        <div class="statistics-box flex flex-direction">
            <div class="flex align-center">
                <div class="page-title">会员统计</div>
                <el-date-picker
                    class="margin-left"
                    v-model="huiyuan_time"
                    type="daterange"
                    range-separator="至"
                    :default-time="['00:00:00', '23:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="mini" @change="tongJiUserNumberByTime"/>
            </div>
            <div class="member-num flex margin-top-sm">
                <div class="total flex align-center">
                    <p>会员数量：</p>
                    <b>{{ huiyuan_total.allcount }}</b>
                </div>
                <div class="total flex align-center margin-lr-sm">
                    <p>新入会数量：</p>
                    <b>{{ huiyuan_total.newcount }}</b>
                </div>
                <div class="total flex align-center">
                    <p>到期数量：</p>
                    <b>{{ huiyuan_total.endcount }}</b>
                </div>
            </div>
        </div>
        <div class="statistics-box flex flex-direction margin-top-sm">
            <div class="flex align-center">
                <div class="page-title">会费统计</div>
                <el-date-picker
                    class="margin-left"
                    v-model="huifei_time"
                    type="daterange"
                    range-separator="至"
                    :default-time="['00:00:00', '23:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="mini" @change="tongJiUserFeeByTime"/>
            </div>
            <div class="member-num flex margin-top-sm">
                <div class="total flex align-center">
                    <p>会费金额：</p>
                    <b>{{ huifei_total.pricecount }}</b>
                </div>
                <div class="total flex align-center margin-lr-sm">
                    <p>缴费人数：</p>
                    <b>{{ huifei_total.paycount }}</b>
                </div>
            </div>
        </div>
        <div class="flex align-center justify-between margin-tb-sm">
            <div class="statistics-box flex-sub margin-right-xs">
                <div class="flex align-center statistics-title">
          <span
              :class="{ active: statisticsType === 1 }"
              @click="statisticsType = 1"
          >单位会员统计</span
          >
                    <span
                        :class="{ active: statisticsType === 2 }"
                        @click="statisticsType = 2"
                    >单位会员地区统计</span
                    >
                    <span
                        :class="{ active: statisticsType === 3 }"
                        @click="statisticsType = 3"
                    >个人会员统计</span
                    >
                    <span
                        :class="{ active: statisticsType === 4 }"
                        @click="statisticsType = 4"
                    >个人会员地区统计</span
                    >
                </div>
                <div>
                    <pie-statistics-modular
                        :id="'member'"
                        :data="statisticsType === 1 ? memberData: ( statisticsType === 2 ? addressData : (statisticsType === 3 ? memberPersonalData : addressPersonalData))"
                        :title="'会员人数统计'"
                    />
                </div>
            </div>
            <div class="statistics-box flex-sub margin-left-xs">
                <div class="flex align-center statistics-title">
                    <span class="active">会员等级统计</span>
                </div>
                <pie-statistics-modular
                    :id="'level'"
                    :data="levelData"
                    :title="'会员等级统计'"
                />
            </div>
        </div>
        <div class="statistics-box margin-bottom-sm">
            <div class="flex align-center statistics-title">
                <span
                    :class="{ active: increaseType === 1 }"
                    @click="increaseType = 1"
                >单位会员续费统计</span
                >
                <span
                    :class="{ active: increaseType === 2 }"
                    @click="increaseType = 2"
                >个人会员续费统计</span
                >
            </div>
            <bp-statistics-modular
                :id="'pay'"
                :increase="increaseType === 1? increaseData : increasePersonalData"
                :month="increaseType === 1? month : monthPersonal"
                :outData="increaseType === 1 ? outData : outPersonalData"
                :reduce="increaseType === 1 ? reduceData : reducePersonalData"
                :title="'会员续费统计'"
                :total="increaseType === 1 ? totalData : totalPersonalData"
            />
        </div>
        <div class="statistics-box margin-bottom-sm">
            <div class="flex align-center statistics-title">
                <span class="active">机构数据</span>
            </div>
            <line-statistics-modular
                :id="'org'"
                :month="monthDate"
                :title="'机构数据'"
                :total="orgData"
            />
        </div>

        <div class="member-num-box flex flex-wrap align-center">
            <div v-for="(item,index) in customTotals" :key="index" class="total margin-bottom-sm">
                <p>{{ item.title }}：</p>
                <b>{{ item.number }}</b>
            </div>
        </div>
    </div>
</template>

<script>
import PieStatisticsModular from '@/components/PieStatisticsModular'
import BpStatisticsModular from '@/components/BpStatisticsModular.vue'
import LineStatisticsModular from '@/components/LineStatisticsModular.vue'
import {
    customFieldStatistics,
    getUserGradeStatistics,
    getUserNumberStatistics,
    getUserNumberStatisticsByRegion,
    getUserNumberStatisticsByRegionPersonal,
    getUserNumberStatisticsPersonal,
    jiGouShuJu, tongJiUserFeeByTime,
    tongJiUserNumber, tongJiUserNumberByTime,
    userRenewStatistics,
    userRenewStatisticsPersonal,
} from "@/api/organiz";

export default {
    name: "index",
    data() {
        return {
            passNum: 0,
            examNum: 0,
            expireNum: 0,


            statisticsType: 1,
            memberData: [],
            memberPersonalData: [],
            addressData: [],
            addressPersonalData: [],
            levelData: [],
            month: [],
            monthPersonal: [],

            increaseType: 1,
            increasePersonalData: [],
            increaseData: [],
            reduceData: [],
            reducePersonalData: [],
            outData: [],
            outPersonalData: [],
            totalData: [],
            totalPersonalData: [],
            monthDate: [],
            orgData: [],

            customTotals: [],

            huiyuan_time: [],
            huiyuan_total: [],
            huifei_time: [],
            huifei_total: [],
        }
    },
    created() {
        this.$emit('setIndex', [7, 0], '数据统计')
        this.tongJiUserNumber()
        this.getUserNumberStatistics()
        this.getUserNumberStatisticsPersonal()
        this.getUserNumberStatisticsByRegion()
        this.getUserNumberStatisticsByRegionPersonal()
        this.getUserGradeStatistics()
        this.userRenewStatistics()
        this.userRenewStatisticsPersonal()
        this.jiGouShuJu()
        this.customFieldStatistics()
        this.tongJiUserNumberByTime()
        this.tongJiUserFeeByTime()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    components: {
        PieStatisticsModular,
        BpStatisticsModular,
        LineStatisticsModular
    },
    methods: {
        async tongJiUserNumberByTime(){
            let _data = await tongJiUserNumberByTime(this.huiyuan_time && this.huiyuan_time.length ? this.huiyuan_time[0] : '', this.huiyuan_time && this.huiyuan_time.length ? this.huiyuan_time[1] : '')
            this.huiyuan_total = _data.data
        },
        async tongJiUserFeeByTime(){
            let _data = await tongJiUserFeeByTime(this.huifei_time && this.huifei_time.length ? this.huifei_time[0] : '', this.huifei_time && this.huifei_time.length ? this.huifei_time[1] : '')
            this.huifei_total = _data.data
        },
        async customFieldStatistics() {
            let _data = await customFieldStatistics()
            this.customTotals = _data.data
        },
        async tongJiUserNumber() {
            let _data = await tongJiUserNumber()
            this.passNum = _data.data.usersCountAll
            this.examNum = _data.data.usersCheckAll
            this.expireNum = _data.data.usersRenewAll
        },
        async getUserNumberStatistics() {
            let _data = await getUserNumberStatistics()
            _data.data.map(item => {
                this.memberData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.num
                })
            })

        },
        async getUserNumberStatisticsPersonal() {
            let _data = await getUserNumberStatisticsPersonal()
            _data.data.map(item => {
                this.memberPersonalData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.num
                })
            })

        },
        async getUserNumberStatisticsByRegion() {
            let _data = await getUserNumberStatisticsByRegion()
            _data.data.map(item => {
                this.addressData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.num
                })
            })

        },
        async getUserNumberStatisticsByRegionPersonal() {
            let _data = await getUserNumberStatisticsByRegionPersonal()
            _data.data.map(item => {
                this.addressPersonalData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.num
                })
            })

        },
        async getUserGradeStatistics() {
            let _data = await getUserGradeStatistics()
            _data.data.map(item => {
                this.levelData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.number
                })
            })
        },
        async userRenewStatistics() {
            let _data = await userRenewStatistics()
            _data.data.huiYuanShuLiangData.map(item => {
                this.month.push(item.monthdata)
            })
            this.increaseData = this.zhValue2(_data.data.daoQiData)
            this.reduceData = this.zhValue2(_data.data.xuFeiData)
            this.outData = this.zhValue2(_data.data.tuiHuiData)
            this.totalData = this.zhValue2(_data.data.huiYuanShuLiangData)


        },
        async userRenewStatisticsPersonal() {
            let _data = await userRenewStatisticsPersonal()
            _data.data.huiYuanShuLiangData.map(item => {
                this.monthPersonal.push(item.monthdata)
            })
            this.increasePersonalData = this.zhValue2(_data.data.daoQiData)
            this.reducePersonalData = this.zhValue2(_data.data.xuFeiData)
            this.outPersonalData = this.zhValue2(_data.data.tuiHuiData)
            this.totalPersonalData = this.zhValue2(_data.data.huiYuanShuLiangData)


        },
        async jiGouShuJu() {
            let _data = await jiGouShuJu()
            let _arr1 = this.zhValue(_data.data.tongZhiGongGao)
            let _arr2 = this.zhValue(_data.data.jiGouDongTai)
            let _arr3 = this.zhValue(_data.data.huoDongGuanLi)
            let _arr4 = this.zhValue(_data.data.fuWuShenQing)
            _data.data.jiGouDongTai.map(item => {
                this.monthDate.push(item.date)
            })
            this.orgData = [
                {
                    name: '通知公告',
                    type: 'line',
                    data: _arr1
                },
                {
                    name: '机构动态',
                    type: 'line',
                    data: _arr2
                },
                {
                    name: '活动管理',
                    type: 'line',
                    data: _arr3
                },
                {
                    name: '服务申请',
                    type: 'line',
                    data: _arr4
                }
            ]
        },

        zhValue(arr) {
            let _arr = []
            arr.map(item => {
                _arr.push(item.number)
            })
            return _arr
        },
        zhValue2(arr) {
            let _arr = []
            arr.map(item => {
                _arr.push(item.num)
            })
            return _arr
        }

    }

}
</script>

<style lang="scss" scoped>
.wrapper {
    .member-num-box {
        .total {
            &:not(:nth-child(4n+1)) {
                margin-left: 20px;
            }

            width: 230px;
            height: 100px;
            border-radius: 10px;
            padding: 10px;
            border: solid 1px rgba($color: #fff, $alpha: 0.5);
            background: rgba($color: #fff, $alpha: 0.3);
            position: relative;

            b {
                position: absolute;
                display: block;
                text-align: center;
                font-size: 36px;
                color: #ff9600;
                right: 10px;
                bottom: 10px;
            }

            p {
                font-size: 18px;
                line-height: 22px;
                color: #ffffff;
            }
        }

        .member-num {
            display: block;
            width: 312px;
            height: 100px;
            border-radius: 10px;
            padding: 10px 0;
            border: solid 1px rgba($color: #fff, $alpha: 0.5);
            background: rgba($color: #fff, $alpha: 0.3);

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ffffff, #ffffff);
                background-blend-mode: normal, normal;

                b {
                    color: #fff;
                }
            }

            b {
                display: block;
                text-align: center;
                font-size: 40px;
                line-height: 48px;
                color: #ff9600;
            }

            p {
                font-size: 18px;
                line-height: 34px;
                color: #ffffff;
                text-align: center;
            }
        }
    }

    .menu-box {
        padding: 20px 20px 0;
        background: rgba($color: #fff, $alpha: 0.2);
        border-radius: 10px;

        .menu-item {
            display: block;
            width: 139px;
            height: 70px;
            text-align: center;
            line-height: 68px;
            font-size: 18px;
            color: #fff;
            border-radius: 10px;
            margin: 0 20px 20px 0;
            border: solid 1px rgba($color: #fff, $alpha: 0.5);
            background: rgba($color: #fff, $alpha: 0.2);

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%);
            }

            &:nth-child(6n) {
                margin-right: 0;
            }
        }
    }

    .statistics-box {
        padding: 20px;
        background: #fff;
        border-radius: 10px;

        .total {
            width: calc((100% - 40px) / 3);
            height: 60px;
            border-radius: 10px;
            padding: 20px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#ffffff, #ffffff);
            background-blend-mode: normal, normal;
            b {
                display: block;
                text-align: center;
                font-size: 22px;
                line-height: 48px;
                color: #ffffff;
            }

            p {
                font-size: 16px;
                line-height: 34px;
                color: #ffffff;
                text-align: center;
            }
        }

        .statistics-title {
            width: max-content;


            span {
                display: block;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border: 1px solid #ffb400;
                color: #ffb400;
                border-right: 0;
                padding: 0 5px;
                cursor: pointer;

                &:first-child {
                    border-top-left-radius: 6px;
                    border-bottom-left-radius: 6px;
                }

                &:last-child {
                    border-top-right-radius: 6px;
                    border-bottom-right-radius: 6px;
                    border-right: 1px solid #ffb400;
                }

                &.active {
                    background-color: #ff9600;

                    color: #fff;
                }
            }
        }
    }
}
</style>
